import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import FieldsetContainer from '@/components/shared/FieldsetContainer';
import { Button, TextInput } from '@/components/ui/daisy';

type LessonPlanInlineFormFields = {
  name: string;
};

type LessonPlanInlineFormProps = {
  defaultValues?: LessonPlanInlineFormFields;
  onSubmit: (data: LessonPlanInlineFormFields) => void;
  onCancel: () => void;
  isLoading?: boolean;
};

export default function LessonPlanInlineForm({
  defaultValues,
  onSubmit,
  onCancel,
  isLoading,
}: LessonPlanInlineFormProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.lessonPlansTab',
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LessonPlanInlineFormFields>({
    defaultValues: defaultValues ?? { name: '' },
  });

  return (
    <FieldsetContainer>
      <form className="flex flex-col gap-4" onSubmit={handleSubmit(onSubmit)}>
        <TextInput.Fieldset label={t('name')} labelAlt={errors?.name?.message}>
          <TextInput
            type="text"
            placeholder={t('namePlaceholder')}
            className="w-full"
            color={!errors?.name?.message ? 'default' : 'error'}
            {...register('name', { required: t('nameRequired') })}
          />
        </TextInput.Fieldset>
        <div className="flex justify-end gap-2">
          <Button
            type="button"
            className="grow bg-base-300"
            onClick={onCancel}
            disabled={isLoading}
          >
            {t('cancel')}
          </Button>
          <Button
            type="submit"
            color="secondary"
            className="grow"
            disabled={isLoading}
            loading={isLoading}
          >
            {t('save')}
          </Button>
        </div>
      </form>
    </FieldsetContainer>
  );
}
